// extracted by mini-css-extract-plugin
export default {"bold":"CvlRow_bold__1jWCt"};